import colors from '~lib/styles/Theme/colors';

export const LINE_STYLE = {
  backgroundColor: colors.magenta500,
  borderColor: colors.magenta500,
  borderWidth: 1,
};

export const POINT_STYLE = {
  pointStyle: 'circle',
  pointBorderColor: colors.magenta500,
  pointRadius: 3.5,
  pointHoverRadius: 5,
  pointHoverBorderWidth: 4,
  pointHoverBackgroundColor: colors.white100,
};

export const DEFAULT_CHART_STYLE = {
  borderWidth: 0,
};

export const DEFAULT_OPTIONS = {
  animation: {
    duration: 100,
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      labels: {
        value: {
          display: false,
        },
      },
    },
  },
  parsing: {
    xAxis: 'hired',
    yAxis: 'left',
  },
  scales: {
    y: {
      ticks: {
        display: false,
      },
      grid: {
        drawBorder: false,
        color: colors.gray300,
      },
    },
    x: {
      ticks: {
        autoSkip: true,
        font: {
          weight: '500',
          lineHeight: '12px',
          size: '10px',
          family: 'Pretendard',
        },
        color: colors.gray700,
      },
      grid: {
        display: false,
      },
    },
  },
};

export const TOOLTIP_LINE_PLUGINS = {
  id: 'tooltipLine',
  // @ts-ignore
  beforeDraw: (chart) => {
    if (chart.tooltip._active && chart.tooltip._active.length) {
      const ctx = chart.ctx;
      ctx.save();
      const activePoint = chart.tooltip._active[0];

      ctx.beginPath();
      ctx.setLineDash([2, 2]);
      ctx.moveTo(activePoint.element.x, chart.chartArea.top);
      ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = colors.gray600;
      ctx.stroke();
      ctx.restore();
    }
  },
};

export const TOOLTIP_CONNECT_DASH = {
  // @ts-ignore
  afterDraw: (chart) => {
    const ctx = chart.ctx;
    ctx.save();

    const datasets = chart.data.datasets;
    const { data: lineChartData } = datasets[0];

    ctx.strokeStyle = colors.magenta500;

    let xFrom: number | null = null;
    let yFrom: number | null = null;
    let dirty: boolean = false;

    const { data } = chart.getDatasetMeta(0);

    if (!data || data.length === 0) {
      return true;
    }

    // @ts-ignore
    data.forEach((obj, index) => {
      if (index === lineChartData.length - 1) {
        return;
      }

      const { x, y, skip } = obj;
      const isNextSkiped = data[index + 1]?.skip;

      if (!skip && isNextSkiped) {
        xFrom = x;
        yFrom = y;
        dirty = true;
      }

      if (skip && !isNextSkiped && dirty) {
        const targetX = data[index + 1]?.x;
        const targetY = data[index + 1]?.y;
        ctx.lineWidth = 1;
        ctx.setLineDash([2, 2]);
        ctx.beginPath();

        ctx.moveTo(xFrom, yFrom);
        ctx.lineTo(targetX, targetY);
        ctx.stroke();

        xFrom = null;
        yFrom = null;
      }
    });
    ctx.restore();
  },
};
